module.exports = __webpack_public_path__ + "static/baking-bad_2-89883360f1c6a09e4e0221e1dbb7be4b.jpeg";